import { Component, ViewChild, signal, Injector, AfterViewInit, afterNextRender, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { effect } from '@angular/core';
import { NotificationService } from '@/share/services/notification-service';

@Component({
    selector: 'app-notification',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './notification.component.html'
})
export class NotificationComponent {
    activeTab: 'inbox' | 'general' | 'archived' = 'inbox';
    _activeTab = signal<string>(this.activeTab);
    tabs = [
        { key: 'inbox', label: 'Inbox', count: 2 },
        { key: 'general', label: 'General', count: 0 },
        { key: 'archived', label: 'Archived', count: 0 }
    ];

    allNotifications = signal([
        {
            id: 1,
            label: 'N jonh',
            subtitle: 'You have a new message...',
            time: '11 minutes ago',
            avatar: 'assets/avatars/1.png',
            read: false,
            tab: 'inbox'
        },
        {
            id: 2,
            label: 'Justin Go',
            subtitle: 'You have a new message...',
            time: '1 hour ago',
            avatar: 'assets/avatars/2.png',
            read: false,
            tab: 'inbox'
        },
        {
            id: 3,
            label: 'Sok Pisey',
            subtitle: 'You have a new message...',
            time: 'Yesterday at 2:32 PM',
            avatar: 'assets/avatars/3.png',
            read: true,
            tab: 'inbox'
        }
    ]);
    items = signal<any[]>([]);

    constructor(private notifService: NotificationService) {
        this.items.set(this.allNotifications());
    }

    markAsRead(id: number) {
        this.allNotifications.update((list) => list.map((n) => (n.id === id ? { ...n, read: true } : n)));
    }

    markAllAsRead() {
        this.allNotifications.update((list) => list.map((n) => ({ ...n, read: true })));
    }
}
